import styled from 'styled-components';
import { buttonSecondaryStyles, buttonSecondaryHoverStyles, buttonSecondaryActiveStyles } from '@nicollet/common';
export { buttonSecondaryActiveStyles, buttonSecondaryHoverStyles, buttonSecondaryStyles } from '@nicollet/common';
import { BaseButton } from '../BaseButton/index.js';

const ButtonSecondary = styled(BaseButton)`
  ${buttonSecondaryStyles}

  &:hover {
    ${buttonSecondaryHoverStyles}
  }

  &:active {
    ${buttonSecondaryActiveStyles}
  }
`;

export { ButtonSecondary };
